import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ReclamationWeekPlanningView } from "src/components/views/erp/reclamation/weekPlanning/ReclamationWeekPlanningView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/reclamations/weekPlanning")({
	staticData: { title: i18n.t("week_planning"), legacyViewKey: "reclamationWeekPlanningPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ReclamationWeekPlanningView />;
}
